<form
  id="informations-client-form"
  class="px-4"
  [formGroup]="informationsClientForm"
>
  <div class="row">
    <div class="col-6">
      <div class="mb-3">
        <p-input
          [formControl]="this.informationsClientForm.controls.lastname"
          id="lastname"
          name="lastname"
          label="Nom"
          [tabindex]="1"
          (input)="lastnameChanged($event)"
        ></p-input>
      </div>

      <div class="mb-3">
        <p-input
          [formControl]="this.informationsClientForm.controls.phone"
          id="phone"
          name="phone"
          label="Téléphone"
          [tabindex]="3"
          [maxLengthNumber]="20"
          errorMessage="Numéro de téléphone invalide"
          (input)="phoneChanged($event)"
        ></p-input>
      </div>
    </div>

    <div class="col-6">
      <div class="mb-3">
        <p-input
          [formControl]="this.informationsClientForm.controls.firstname"
          id="firstname"
          name="firstname"
          label="Prénom"
          [tabindex]="2"
          (input)="firstnameChanged($event)"
        ></p-input>
      </div>

      <div class="mb-3">
        <p-input
          [formControl]="this.informationsClientForm.controls.email"
          id="email"
          name="email"
          label="Email"
          [tabindex]="4"
          errorMessage="Adresse éléctronique invalide"
          (input)="emailChanged($event)"
        ></p-input>
      </div>
    </div>
  </div>

  <div class="mb-3">
    <p-input
      [formControl]="this.informationsClientForm.controls.address"
      id="address"
      name="address"
      label="Adresse"
      [tabindex]="5"
      (input)="addressChanged($event)"
    ></p-input>
  </div>

  <div class="row">
    <div class="col-6">
      <div class="mb-3">
        <p-input
          [formControl]="this.informationsClientForm.controls.postalCode"
          id="postalCode"
          name="postalCode"
          label="Code postal"
          [tabindex]="6"
          [maxLengthNumber]="5"
          type="number"
          (input)="postalCodeChanged($event)"
        ></p-input>
      </div>
    </div>

    <div class="col-6">
      <div class="mb-3">
        <p-input
          [formControl]="this.informationsClientForm.controls.city"
          id="city"
          name="city"
          label="Ville"
          [tabindex]="7"
          (input)="cityChanged($event)"
        ></p-input>
      </div>
    </div>
  </div>
</form>
